export default "__VITE_ASSET__BEpseSQu__"